import { render, staticRenderFns } from "./ResetPasswordWithTokenPage.vue?vue&type=template&id=6266255a&scoped=true"
import script from "./ResetPasswordWithTokenPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPasswordWithTokenPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResetPasswordWithTokenPage.vue?vue&type=style&index=0&id=6266255a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6266255a",
  null
  
)

export default component.exports